export default {
      id: "icon--menu-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--menu-usage",
      toString: function () {
        return this.url;
      }
    }